import React, { useEffect, useState } from 'react'


export default function STPPreventiveSewerageQuality_B_Data({ tableData, DeletePopupShow }) {

    return (
        <div>

            <div className="row mob_table table-responsive pt-1">
                <table id="totalordergenerated"
                    cellPadding="0"
                    cellSpacing="0"
                    border="0"
                    className="table table-bordered">

                    <thead>
                        <tr>
                            <th rowSpan="2" className="sr_no_col">Sr No.</th>
                            <th rowSpan="2">Date</th>
                            <th colSpan="4" className='new_grid'>MLSS (Mg / L)</th>
                            <th colSpan="4" className='new_grid'>MLVSS (Mg / L)</th>
                            <th colSpan="4" className='new_grid'>SV30</th>
                            <th colSpan="4" className='new_grid'>SV1 (MLD)</th>
                            {/* <th rowSpan="2">Action</th> */}
                        </tr>
                        <tr>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 1</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 2</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 3</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 4</th>
                            {/* <th style={{whiteSpace:'nowrap'}}>Tank 5</th>
                            <th style={{whiteSpace:'nowrap'}}>Tank 6</th> */}
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 1</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 2</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 3</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 4</th>
                            {/* <th style={{whiteSpace:'nowrap'}}>Tank 5</th>
                            <th style={{whiteSpace:'nowrap'}}>Tank 6</th> */}
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 1</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 2</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 3</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 4</th>
                            {/* <th style={{whiteSpace:'nowrap'}}>Tank 5</th>
                            <th style={{whiteSpace:'nowrap'}}>Tank 6</th> */}
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 1</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 2</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 3</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Tank 4</th>
                            {/* <th style={{whiteSpace:'nowrap'}}>Tank 5</th>
                            <th style={{whiteSpace:'nowrap'}}>Tank 6</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            tableData && tableData.length > 0 ? tableData.map((item) => (
                                <tr>
                                    <td style={{ textAlign: "center" }}>{item.srNo ? item.srNo : '-'}</td>
                                    <td>{item.readingDate ? item.readingDate : '-'}</td>
                                    <td>{item.mlsS_Mg_L_Tank_1 ? item.mlsS_Mg_L_Tank_1 : '0'}</td>
                                    <td>{item.mlsS_Mg_L_Tank_2 ? item.mlsS_Mg_L_Tank_2 : '0'}</td>
                                    <td>{item.mlsS_Mg_L_Tank_3 ? item.mlsS_Mg_L_Tank_3 : '0'}</td>
                                    <td>{item.mlsS_Mg_L_Tank_4 ? item.mlsS_Mg_L_Tank_4 : '0'}</td>
                                    <td>{item.mlvsS_Mg_L_Tank_1 ? item.mlvsS_Mg_L_Tank_1 : '0'}</td>
                                    <td>{item.mlvsS_Mg_L_Tank_2 ? item.mlvsS_Mg_L_Tank_2 : '0'}</td>
                                    <td>{item.mlvsS_Mg_L_Tank_3 ? item.mlvsS_Mg_L_Tank_3 : '0'}</td>
                                    <td>{item.mlvsS_Mg_L_Tank_4 ? item.mlvsS_Mg_L_Tank_4 : '0'}</td>
                                    <td>{item.sV30_Tank_1 ? item.sV30_Tank_1 : '0'}</td>
                                    <td>{item.sV30_Tank_2 ? item.sV30_Tank_2 : '0'}</td>
                                    <td>{item.sV30_Tank_3 ? item.sV30_Tank_3 : '0'}</td>
                                    <td>{item.sV30_Tank_4 ? item.sV30_Tank_4 : '0'}</td>
                                    <td>{item.svI_Tank_1 ? item.svI_Tank_1 : '0'}</td>
                                    <td>{item.svI_Tank_2 ? item.svI_Tank_2 : '0'}</td>
                                    <td>{item.svI_Tank_3 ? item.svI_Tank_3 : '0'}</td>
                                    <td>{item.svI_Tank_4 ? item.svI_Tank_4 : '0'}</td>
                                </tr>
                            ))
                                :
                                <></>
                        }
                    </tbody>
                </table>

            </div>
        </div>
    )
}